module.exports = __webpack_public_path__ + "img/ic-montee_escalier.88a22835.svg";